export default "__VITE_ASSET__f41ce749__"